import PropTypes from 'prop-types';

const Page = ({ children }) => <div className="py-8 px-10">{children}</div>;

Page.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Page;
